import { useCallback, useState } from 'react';

type UseToggleReturnType = [boolean, () => void];

/**
 * Boolean 타입을 toggle 해주는 훅
 *
 * */
export const useToggle = (initialValue = false): UseToggleReturnType => {
  const [value, setValue] = useState<boolean>(initialValue);
  const toggleValue = useCallback(() => {
    setValue(currentValue => !currentValue);
  }, []);
  return [value, toggleValue];
};
